export const URL_CONFIG = {
    APP: {
        url: process.env.REACT_APP_ENVIRONMENT
    },
    API: {
        url: process.env.REACT_APP_API_URL
    },
    GOOGLE_MAP: {
        embed: process.env.REACT_APP_GOOGLE_MAPS_API_KEY_EMBED,
        private: process.env.REACT_APP_GOOGLE_MAPS_API_KEY_PRIVATE,
        mapId: process.env.REACT_APP_GOOGLE_MAPS_ID
    },
    DOMAIN_WORDPRESS: {
        url: process.env.REACT_APP_DOMAIN_WORDPRESS_URL
    }
};
